var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottom-box" }, [
    _c(
      "div",
      { staticClass: "bottom-left" },
      [
        _c("el-card", { staticClass: "box-cards" }, [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("常用功能")])]
          ),
          _c("div", { staticClass: "cards-content" }, [
            _c(
              "div",
              { staticClass: "application" },
              _vm._l(_vm.applicationData, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    on: {
                      click: function ($event) {
                        return _vm.jump(item.url, item.authBtn)
                      },
                    },
                  },
                  [
                    item.icon
                      ? _c("img", {
                          staticStyle: {
                            width: "1em",
                            height: "1em",
                            "margin-left": "24px",
                          },
                          attrs: { src: item.icon, alt: "" },
                        })
                      : _c("icon-svg", { attrs: { name: "ben" } }),
                    _c("div", [_vm._v(_vm._s(item.name))]),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bottom-right" },
      [
        _c("el-card", { staticClass: "box-cards" }, [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("常用链接")])]
          ),
          _c("div", { staticClass: "cards-content" }, [
            _c(
              "div",
              { staticClass: "links" },
              _vm._l(_vm.linkData, function (item, index) {
                return _c("div", { key: index, staticClass: "link-box" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "48px",
                        height: "48px",
                        "margin-left": "24px",
                      },
                    },
                    [
                      item.icon
                        ? _c("img", {
                            staticStyle: { width: "48px", height: "48px" },
                            attrs: { src: item.icon, alt: "" },
                          })
                        : _c("img", {
                            attrs: { src: _vm.getImgUrl(index), alt: "" },
                          }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.jumpLink(item.url, item.authBtn)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(item.name))]),
                      _c("span", [_vm._v("进入")]),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }